import { Resource } from "@domain/base/Resource";
import { IMontaConnectorRepository } from "@domain/connection/IMarketplaceRepository";
import { Connection } from "@domain/connection/models/Connection";
import { Product } from "@domain/product/models/Product";
import { MontaConnectorDataSource } from "../datasources/MontaConnectorDataSource";
import { ConnectionMapper } from "../mappers/MarketplaceMapper";
import { MontaProduct } from "@domain/connection/models/MontaProduct";
import { FullSyncJob } from "@domain/connection/models/ImportJob";

export class MontaConnectorRepository implements IMontaConnectorRepository {

    constructor(private dataSource: MontaConnectorDataSource) { }

    async addMontaMarketplaceConnection(code: string, redirectUri: string): Promise<Resource<Connection>> {
        try {
            const data = await this.dataSource.addMontaMarketplaceConnection(code, redirectUri);
            return {
                status: 'success',
                data: ConnectionMapper.toConnectionModel(data)
            };
        } catch (error) {
            return {
                status: 'error',
                error: {
                    type: 'UnknownError',
                    message: 'Failed to add Monta connection'
                }
            };
        }
    }

    async fetchProducts(connectionId: string): Promise<Resource<MontaProduct[]>> {
        try {
            const data = await this.dataSource.fetchProducts(connectionId);
            return {
                status: 'success',
                data: data
            };
        } catch (error) {
            return {
                status: 'error',
                error: {
                    type: 'UnknownError',
                    message: 'Failed to fetch Monta products'
                }
            };
        }
    }

    async syncFull(connectionId: string): Promise<Resource<FullSyncJob[]>> {
        try {
            const data = await this.dataSource.syncFull(connectionId);
            return { status: 'success', data };
        } catch (error) {
            return {
                status: 'error',
                error: {
                    type: 'UnknownError',
                    message: 'Failed to start full sync'
                }
            };
        }
    }

    async reconnect(connectionId: string, username: string, password: string): Promise<Resource<Connection>> {
        try {
            const data = await this.dataSource.reconnect(connectionId, username, password);
            return { status: 'success', data: ConnectionMapper.toConnectionModel(data) };
        } catch (error) {
            return {
                status: 'error',
                error: {
                    type: 'UnknownError',
                    message: 'Failed to reconnect Monta connection'
                }
            };
        }
    }
}